import * as React from "react";
import AdminLink from "./AdminLink";

export const Navigator = ({ name, page, role }: any) => {
  return <AdminLink name={name} page={page} roles={role} />;
};
